module.exports = __webpack_public_path__ + "img/p2_12.7d9ca7da.webp";